export const initialState = {
    orgId: "",
    orgName: "",
    isSupportMode: false    
};
  